// Pure-JS query layer — identical interface to the DuckDB variant in the spec (§7)

function measureFn(measure) {
  const m = /^(\w+)\((.*)\)$/.exec(measure.trim());
  if (!m) throw new Error(`Bad measure: ${measure}`);
  const [, fn, arg] = m;
  switch (fn.toUpperCase()) {
    case "SUM":
      return (rows) => rows.reduce((s, r) => s + (Number(r[arg]) || 0), 0);
    case "COUNT":
      return (rows) => rows.length;
    case "AVG":
      return (rows) => {
        const nums = rows.map((r) => Number(r[arg])).filter((v) => Number.isFinite(v));
        return nums.length ? nums.reduce((s, v) => s + v, 0) / nums.length : 0;
      };
    case "COUNT_DISTINCT":
      return (rows) => new Set(rows.map((r) => r[arg])).size;
    default:
      throw new Error(`Unknown agg: ${fn}`);
  }
}

export function filterRows(facts, filters = {}) {
  const entries = Object.entries(filters);
  if (!entries.length) return facts;
  return facts.filter((r) => entries.every(([k, v]) => String(r[k]) === String(v)));
}

export function runDrill(facts, q) {
  const rows = filterRows(facts, q.filters);
  if (!q.groupBy?.length) return rows; // leaf: raw atomic records

  const fn = measureFn(q.measure || "COUNT(*)");
  const groups = new Map();
  for (const r of rows) {
    const key = q.groupBy.map((g) => r[g]).join("\u00a6");
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(r);
  }
  let out = [...groups.entries()].map(([key, rs]) => {
    const parts = key.split("\u00a6");
    const dims = Object.fromEntries(q.groupBy.map((g, i) => [g, parts[i]]));
    return { ...dims, value: fn(rs), _count: rs.length };
  });
  if (q.orderBy === "dim") out.sort((a, b) => String(a[q.groupBy[0]]).localeCompare(String(b[q.groupBy[0]])));
  else out.sort((a, b) => Math.abs(b.value) - Math.abs(a.value));
  if (q.limit) out = out.slice(0, q.limit);
  return out;
}

export function measure(facts, m, filters) {
  return measureFn(m)(filterRows(facts, filters));
}
